import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { Table } from '../../Table/Table.es.js';

const AdvancedTableRowSubComponent = ({ row, getRowSubComponent })=>{
    const rowSubComponent = useMemo(()=>getRowSubComponent?.(row), [
        getRowSubComponent,
        row
    ]);
    if (rowSubComponent == null || !row.getIsExpanded()) {
        return null;
    }
    return jsx(Table.Body.Row, {
        "aria-level": 2,
        children: jsx(Table.Body.Cell, {
            colSpan: row.getVisibleCells().length,
            role: "gridcell",
            children: rowSubComponent
        })
    });
};

export { AdvancedTableRowSubComponent };
//# sourceMappingURL=AdvancedTableRowSubComponent.es.js.map
